import { Box } from '@chakra-ui/react';

/**
 * Метка «доступа нет» на углу кнопки микрофона или камеры.
 *
 * <p>До неё неготовность была невидима: кнопка выглядела исправной, и человек узнавал о запрете
 * от собеседников — либо не узнавал вовсе и уходил. Замер прода за 30 дней: микрофон не дали 28
 * людям из 208, а в первом сеансе человека это случается вдвое чаще, чем в последующих.
 *
 * <p>Оранжевая, не красная. Красный в разговоре занят выходом из него («Leave», сброс трубки), и
 * второй смысл на том же цвете читался бы как «нажми, чтобы прекратить».
 *
 * <p>Родитель обязан быть `position: relative` — метка садится на его угол.
 */
export const AccessBadge = () => (
  <Box
    aria-hidden="true"
    position="absolute"
    top="-4px"
    right="-4px"
    w="16px"
    h="16px"
    borderRadius="full"
    bg="orange.400"
    color="bg"
    display="grid"
    placeItems="center"
    textStyle="micro"
    lineHeight={1}
    // Кольцо цветом подложки: без него метка сливается с краем кнопки на светлых аватарах
    // соседей и на зелёном фоне включённого микрофона.
    boxShadow="0 0 0 2px var(--chakra-colors-bg-surface)"
  >
    !
  </Box>
);
